<template>
    <design-2021-apprentice-line-chart-component
        :options="chartOptions"
        :series="series"
    ></design-2021-apprentice-line-chart-component>
</template>

<script>
export default {
    name: "design-2021-statistics-index-assignments-component",
    props: [
        'assignmentDatasIn',
        'assignmentLabelsIn'
    ],
    data(){
        return {
            series: this.assignmentDatasIn.map((item, key) => {
                return {
                    name: item['name'],
                    data: item['data']
                }
            }),
            chartOptions: {
                chart: {
                    type: 'line',
                    height: 350,
                    toolbar: {
                        show: false
                    }
                },
                colors: [Math.floor(Math.random()* 16777215).toString(16)],
                xaxis: {
                    categories: this.assignmentLabelsIn,
                },
                markers: {
                    size: 4,
                },
                stroke: {
                    curve: 'smooth',
                },
                grid: {
                    show: true,
                    yaxis: {
                        lines: {
                            show: true
                        }
                    },
                    xaxis: {
                        lines: {
                            show: true
                        }
                    }
                }
            }
        }
    },
    computed: {
        customStyles() {
            return {
                height: `${this.height}px`,
                width: '100%',
                position: 'relative',
            }
        },
    },
}
</script>

<style scoped>

</style>
